import { render, staticRenderFns } from "./EditPracticeTest.vue?vue&type=template&id=98940ca4&scoped=true&"
import script from "./EditPracticeTest.vue?vue&type=script&lang=js&"
export * from "./EditPracticeTest.vue?vue&type=script&lang=js&"
import style0 from "./EditPracticeTest.vue?vue&type=style&index=0&id=98940ca4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98940ca4",
  null
  
)

export default component.exports